export default {
    top_menu: [
        {name:'Հիմնական բանը',    id:0},
        {name:'Շոու բիզնես', id:1},
        {name:'Խոհարարություն',  id:2},
        {name:'Քաղաքականություն',   id:3},
        {name:'Կծու',  id:4},
        {name:'Հասարակություն',   id:5},
        {name:'Առողջություն',   id:6},
    ],
    read_other: 'Կարդալ ավելին',
    read_more:  'Ավելի մանրամասն',
    not_found:  'Ոչինչ չի գտնվել',
    read_also:  'Կարդացեք նաև',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Բոլոր իրավունքները պաշտպանված են.',
    subscribe: 'Բաժանորդագրվել',

    thank_order: 'ՇՆՈՐՀԱԿԱԼՈԹՅՈՆ Ձեր պատվերի համար',
    specialist_contact: 'Մեր մասնագետը շուտով կկապվի ձեզ հետ, սպասեք մեր զանգին.',
    attention: 'Գործընկերներից զեղչեր:',
    hurry: 'Շտապեք, զեղչի ակտիվացման ժամանակը սահմանափակ է! Դուք ունեք ընդամենը <span id="time" class="time">30:00</span> րոպե այս եզակի ապրանքներից մեկը ընտրելու համար:',

    hour_ago1: "Ժամ առաջ",
    hour_ago2: "ժամեր առաջ",
    hour_ago3: "ժամեր առաջ",
    new_publications: "Նոր հրապարակումներ",
    read: "Կարդացեք",
    today_at: "Այսօր ՝ ժ",
    author_names: ['Հայրապետյան Լուար','Հակոբյան Գոռ','Արաբյան Քրիսդապոր'],
    main_news: "Հիմնական նորություններ",
    leave_already: "Արդեն հեռանո՞ւմ եք: Սպասեք, մենք թարմացրել ենք նորությունները ձեզ համար",
    already_shared: "արդեն կիսվել է"

}